import { render, staticRenderFns } from "./filterToMe.vue?vue&type=template&id=0b084c37&scoped=true&"
import script from "./filterToMe.vue?vue&type=script&lang=js&"
export * from "./filterToMe.vue?vue&type=script&lang=js&"
import style0 from "./filterToMe.vue?vue&type=style&index=0&id=0b084c37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b084c37",
  null
  
)

export default component.exports